import * as React from "react";
import type { SVGProps } from "react";
const SvgPuzzleMain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <g clipPath="url(#Puzzle-Main_svg__a)">
      <path
        fill="#90B9FF"
        d="M13.235 2H2.41a.4.4 0 0 0-.29.124.43.43 0 0 0-.12.3V13.71c0 .112.043.22.12.3s.181.123.29.123h4.166a.4.4 0 0 0 .222-.067.436.436 0 0 0 .088-.634l-.025-.03a1.36 1.36 0 0 1-.305-.86c0-.731.569-1.325 1.267-1.325s1.266.593 1.266 1.324c0 .323-.113.636-.319.879a.43.43 0 0 0-.076.461.4.4 0 0 0 .154.186.4.4 0 0 0 .228.066h4.16a.4.4 0 0 0 .29-.124.43.43 0 0 0 .12-.299v-2.836c0-.103.088-.183.19-.183 1.194 0 2.164-1.01 2.164-2.25 0-1.242-.97-2.252-2.163-2.252a.19.19 0 0 1-.191-.183V2.423a.43.43 0 0 0-.12-.3.4.4 0 0 0-.29-.123"
        opacity={0.6}
      />
      <path
        fill="#23F6E7"
        d="M3.765 13.133H14.59a.4.4 0 0 0 .29-.124.43.43 0 0 0 .12-.299V1.423a.43.43 0 0 0-.12-.299.4.4 0 0 0-.29-.124h-4.166a.4.4 0 0 0-.222.067.435.435 0 0 0-.088.634l.025.03c.197.24.305.546.305.86 0 .731-.569 1.325-1.267 1.325s-1.266-.592-1.266-1.324c0-.323.113-.635.319-.879a.43.43 0 0 0 .076-.461.4.4 0 0 0-.154-.186A.4.4 0 0 0 7.924 1h-4.16a.4.4 0 0 0-.29.124.43.43 0 0 0-.12.3V4.45a2 2 0 0 0-.19-.009C1.97 4.442 1 5.452 1 6.693s.97 2.251 2.163 2.251q.096 0 .192-.008v3.774c0 .112.043.22.12.3s.18.123.29.123"
      />
    </g>
    <defs>
      <clipPath id="Puzzle-Main_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPuzzleMain;
